import { createAsyncThunk } from '@reduxjs/toolkit'
import { ResolveUrl } from 'features/firebase-app'
import {} from 'models'
import { getBearerToken } from '../../application/application-slice'

export const stripe_web_hook = createAsyncThunk<any, any, any>(
  'auto/stripe/web/hook',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(ResolveUrl('auto/stripe/web/hook'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        })
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)
